import React from 'react';
import {Row, Col} from 'antd';
import {useLocalization} from '../../../Localization/useLocalization';
import CommonAdsListing from './CommonAdsListing';
import './index.css';
import SectionLayout from './../../CommonComponents/Layout/sectionLayout';
import CommonHeroText from '../../CommonComponents/CommonHeroText';

const UserAdsComponent = (props) => {
  const {
    allAdsData,
    setAllAdsData,
    page,
    setPage,
    adFeesOptions,
    zeroFeeData,
    fetchNewData,
    setFetchNewData,
  } = props;

  // Use the new localization hook
  const {ApplicationString} = useLocalization();

  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRowJobsListingPage'>
        <Col span={24}>
          <CommonHeroText
            heading={ApplicationString['userAdsComponent.heading']}
            subheading={''}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <span className='jobListingPageContentHeading'>
              {ApplicationString['userAdsComponent.contentHeading']}
            </span>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <CommonAdsListing
            allAdsData={allAdsData}
            setAllAdsData={setAllAdsData}
            page={page}
            setPage={setPage}
            adFeesOptions={adFeesOptions}
            zeroFeeData={zeroFeeData}
            fetchNewData={fetchNewData}
            setFetchNewData={setFetchNewData}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserAdsComponent;
